import type { FreightBookingFormState, WizardStepId } from './freight-booking-wizard-types';

export const hasStepErrors = (step: WizardStepId, formState: FreightBookingFormState): boolean => {
  switch (step) {
    case 'ship-from':
      return !formState.selectedShipFromId || !formState.shipmentDate;

    case 'ship-to':
      return (
        !formState.destinationAddress.name ||
        !formState.destinationAddress.city ||
        !formState.destinationAddress.state ||
        !formState.destinationAddress.postalCode ||
        !formState.destinationAddress.phone ||
        !formState.destinationAddress.email ||
        !formState.destinationAddress.line1
      );

    case 'handling-units': {
      if (formState.handlingUnits.length === 0) return true;
      return formState.handlingUnits.some(
        (unit) =>
          unit.length === 0 ||
          unit.width === 0 ||
          unit.commodities.some((commodity) => commodity.weight === 0 || commodity.freightClass === ''),
      );
    }

    case 'additional-details':
      return false;
  }
};
